export default class UrlOnChange {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    console.log(this.el)
    this.el.addEventListener('change', this.handleChange)
  }

  handleChange(event) {
    const { currentTarget } = event
    console.log(currentTarget.value)
    window.open(currentTarget.value, '_self')
  }
}
